// extracted by mini-css-extract-plugin
export default {"cell":"Table_cell__UkMt7","icon":"Table_icon__SVrwJ","th":"Table_th__z8Jcv"};